import React from 'react';
import { ClockIcon } from 'lucide-react';
import { useLoopingCountdown } from '../hooks/useLoopingCountdown';
type CountdownProps = {
  dark?: boolean;
};
export function Countdown({
  dark = false
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useLoopingCountdown();
  const units = [{
    value: hours,
    label: 'Hours'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Sec'
  }];
  return <div className="mt-6 flex flex-col items-center" role="timer" aria-live="off" data-id="element-98" data-mp="3c13379tj0bnu">
      <p className={`flex items-center gap-2 text-xs font-bold uppercase tracking-wider sm:text-sm ${dark ? 'text-gold-light' : 'text-brand-700'}`} data-id="element-99" data-mp="3h20h3a7i6jjj">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-100" data-mp="3729pbgabuin5" />
        The special offer ends in:
      </p>
      <div className="mt-3 flex items-start gap-2 sm:gap-3" data-id="element-101" data-mp="10c3f3m387q20">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-102" data-mp="15by3nizj43jw" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-103" data-mp="15an2zs1drbx0">
              <span className={`flex h-16 w-16 items-center justify-center rounded-xl font-serif text-3xl font-bold tabular-nums sm:h-20 sm:w-20 sm:text-4xl ${dark ? 'bg-white text-brand-900' : 'bg-brand-800 text-white'}`} data-id="element-104" data-mp="y0epbz8h280f">
                {u.value}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${dark ? 'text-brand-100' : 'text-muted'}`} data-id="element-105" data-mp="12son21ftwcd9">
                {u.label}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-4 font-serif text-2xl font-bold sm:pt-5 ${dark ? 'text-white' : 'text-brand-800'}`} aria-hidden="true" data-id="element-106" data-mp="o4bl8nu27zau">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}